// http://qtip2.com/plugins#viewport
(function() {
    window.addQTipC24Tooltip = function(hoverElement, toolTipSibling, arrowPosition, parentPosition, extraClass, adjustMethod, adjusty, adjustx, useWrapper)
    {
        $.each($(hoverElement), function(_, el) {
            addQTipC24TooltipToElement(el, toolTipSibling, undefined, arrowPosition, parentPosition, extraClass, adjustMethod, adjusty, adjustx, useWrapper);
        });
    };

    window.addQTipC24TooltipText = function(hoverElement, tooltipText, arrowPosition, parentPosition, adjustMethod, extraClass, adjusty, adjustx, useWrapper)
    {
        $.each($(hoverElement), function(_, el) {
            addQTipC24TooltipToElement(el, undefined, tooltipText, arrowPosition, parentPosition, extraClass, adjustMethod, adjusty, adjustx, useWrapper);
        });
    };

    function addQTipC24TooltipToElement(el, toolTipSibling, tooltipText, arrowPosition, parentPosition, extraClass, adjustMethod, adjusty, adjustx, useWrapper) {
        const $el = $(el);
        let pinned = false;
        let dataAdjust = 'shift flip';
        const dataParentPosition = $el.data('parent-position');
        const dataArrowPosition = $el.data('arrow-position');
        const dataExtraClass = $el.data('extra-class');

        if (adjustx === undefined) {
            adjustx = 0;
        }

        if (adjusty === undefined) {
            adjusty = 0;
        }

        if ($el.data('content-id') !== undefined) {
            tooltipText = $('#' + $el.data('content-id')).html();
        } else if (toolTipSibling) {
            const textEl = $el.nextAll(toolTipSibling).first();
            if (textEl) {
                tooltipText = textEl.html();
            }
        }

        if (!window.c24LpNotPinnedQtip || $el.data('pinned')) {
            pinned = true;
        }

        if (dataParentPosition) {
            parentPosition = dataParentPosition;
        }

        if (dataArrowPosition) {
            arrowPosition = dataArrowPosition;
        }

        if (dataExtraClass) {
            extraClass = dataExtraClass;
        }

        if ($el.data('adjust')) {
            dataAdjust = $el.data('adjust');
        }

        if (adjustMethod) {
            dataAdjust = adjustMethod;
        }

        if (arrowPosition === null || parentPosition === null) {
            const ac = $('#c24-content');
            if ($el.offset().left + ($el.width() / 2) > ac.offset().left + (ac.width() / 2)) {
                arrowPosition = 'right center';
                parentPosition = 'left center';
            } else {
                arrowPosition = 'left center';
                parentPosition = 'right center';
            }
        }

        const $fade = $el.closest('.fade');
        if ($fade.length) {

            if (!extraClass) {
                extraClass = 'ppset fade';
            } else {
                extraClass += ' ppset fade';
            }

            if ($fade.hasClass('ffmham')) {
                extraClass += ' ffmham';
            }

            const $ac = $el.closest('.mod24ac');
            if ($ac.length && $ac.data('prefix')) {
                extraClass += ' ' + $ac.data('prefix');
            }
        }

        $el.qtip({
            content: {
                text: tooltipText,
                button: (!pinned ? null : 'Schließen'),
            },
            style: {
                classes: 'c24Editor' + (!pinned ? '' : ' closable') + (extraClass ? ' ' + extraClass : ''),
                tip: {
                    border: 1,
                    width: 16,
                    height: 9,
                },
            },
            show: {
                event: (!pinned ? 'mouseenter' : 'click focus'),
            },
            hide: {
                event: (!pinned ? 'mouseleave focusout' : 'unfocus'),
                fixed: true,
                delay: 500,
            },
            position: {
                viewport: $('html'),
                // Position of the arrow
                my: arrowPosition,
                // Position relative to the parent element
                at: parentPosition,
                adjust: {
                    y: adjusty,
                    x: adjustx,
                    method: dataAdjust,
                },
                effect: false,
            },
            events: {
                move: function(event, api, position) {
                    if (useWrapper !== undefined) {
                        window.c24RepositionQTip(api, position, useWrapper);
                    }
                },
            },
        });
    }

    $(document).ready(function() {

        window.c24LpTooltipEventsBound = true;

        window.addQTipC24Tooltip('.c24Tooltip', '.c24TooltipPopup', 'top center', 'bottom center');
        window.addQTipC24Tooltip('.c24TooltipImage', '.c24TooltipPopup', null, null);
        window.addQTipC24Tooltip('.c24TooltipTop', '.c24TooltipPopup', 'bottom center', 'top center','morePaddingTooltip');

        if ($('.js24GutscheinInfo').length) {
            window.addQTipC24TooltipText('.js24GutscheinInfo', $('.c24GutscheinInfoContent'), 'top center', 'bottom center');
        }
    });

    window.c24 = window.c24 || {};
    window.c24.lp = window.c24.lp || {};
    window.c24.lp.ac = window.c24.lp.ac || {};

    window.c24.lp.ac.initGenericTooltips = function(id) {

        if (!window.c24LpTooltipEventsBound) {
            return;
        }

        window.addQTipC24Tooltip('.mod24ac.' + id + ' .c24Tooltip', '.c24TooltipPopup', 'top center', 'bottom center');
        window.addQTipC24Tooltip('.mod24ac.' + id + ' .c24TooltipImage', '.c24TooltipPopup', null, null);
    };
})();
